<section id="pricing" class="pricing section">
  <div class="container section-title" data-aos="fade-up">
    <h2>Our <span>Pricing</span></h2>
    <p>Choose the Perfect Plan for Your Business Needs</p>
  </div>

  <div class="container">
    <div class="row gy-4 mx-auto justify-content-center">
      <div class="col-lg-4" data-aos="zoom-in" data-aos-delay="100">
        <div class="pricing-item">
          <h3>Free Plan</h3>
          <p class="description">Unlimited invoice</p>
          <h4><sup>$</sup>0<span> / month</span></h4>
          <a [routerLink]="['/auth/sign-up']" class="cta-btn">Start a free</a>
          <!-- <p class="text-center small">No credit card required</p> -->
          <ul>
            <li><i class="bi bi-check"></i> <span>Standard Invoice Templates</span></li>
            <li><i class="bi bi-check"></i> <span>Allow upload company Logo</span></li>
            <li><i class="bi bi-check"></i> <span>Invoice with credit footer</span></li>
            <li class="na"><i class="bi bi-x"></i> <span>No storage</span></li>
            <li class="na"><i class="bi bi-x"></i> <span>No client management</span></li>
          </ul>
        </div>
      </div>

      <div class="col-lg-4" data-aos="zoom-in" data-aos-delay="200">
        <div class="pricing-item featured">
          <p class="popular">Custom</p>
          <h3>Professional Plan</h3>
          <p class="description">Customized Invoice Template</p>
          <h4>Flexible<span> Pricing</span></h4>
          <a [routerLink]="['/contact']" class="cta-btn">Contact Support</a>
          <!-- <p class="text-center small">No credit card required</p> -->
          <ul>
            <li><i class="bi bi-check"></i> <span>Standard Invoice Templates</span></li>
            <li><i class="bi bi-check"></i> <span>Allow upload company Logo</span></li>
            <li><i class="bi bi-check"></i> <span>Invoice without credit footer</span></li>
            <li><i class="bi bi-check"></i> <span>100 invoice storage</span></li>
            <li><i class="bi bi-check"></i> <span>Manage multiple clients</span></li>
            <li><i class="bi bi-check"></i> <span>More...</span></li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</section>